import React, { createElement, Component } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set browser tab title
document.title = 'Talab';
// Set a favicon: a circle using the Talab theme gradient with a white "T"
const faviconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#4338CA"/>
      <stop offset="100%" stop-color="#A855F7"/>
    </linearGradient>
  </defs>
  <circle cx="32" cy="32" r="32" fill="url(#g)"/>
  <text x="32" y="44" font-family="Plus Jakarta Sans, Inter, sans-serif" font-size="40" font-weight="700" fill="#ffffff" text-anchor="middle">T</text>
</svg>`;
const setFavicon = () => {
  const existing = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']");
  existing.forEach(el => el.parentNode?.removeChild(el));
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = `data:image/svg+xml,${encodeURIComponent(faviconSvg)}`;
  document.head.appendChild(link);
};
setFavicon();
render(<App data-id="element-2454" />, document.getElementById('root'));